import React, {useEffect} from 'react'
import { AppDataTable } from '@components'
import { websiteColumn, dorColumn, staticColumn, priceColumn } from './@columns'
import { COLUMN_PARAMS_LIST } from '../@constants'
import RealTimeTableTitle from 'Pages/RealTimeHistory/RealTime/Table/Title'
import { useRealTimeStatus } from 'Pages/RealTimeHistory/RealTime/@hooks'
import { idSearch, isSearching } from 'Pages/RealTimeHistory/RealTime/@signals'
import { Grid } from '@mui/material'
import RealTimeTableErrorsData from 'Pages/RealTimeHistory/RealTime/ErrorData'
import { isEmpty } from '@ui-seeker/utils'
import { dsColorNew } from "@palette"


export default function RealTimeTable() {

	const {
		tableData,
		tableDataAccessDirectSite,
		tableDataAccessBrokers,
		timeStampCreate,
		tableDataErrors,
		firstThirdIndex,
		secondThirdIndex,
		generateTableColor
	} = useRealTimeStatus()

	useEffect(() => {
		generateTableColor()
	}, [JSON.stringify(tableData)])


	return <Grid container spacing={2}>
		{!!Object.values(tableDataErrors).some(e => !isEmpty(e)) && <Grid item xs={12}>
			<RealTimeTableErrorsData tableDataErrors={tableDataErrors} />
		</Grid>}
		{!!tableData.length && <Grid item xs={12}>
			<AppDataTable
				title={<RealTimeTableTitle timeStamp={timeStampCreate}/>}
				data={tableData}
				toolbarProps={{
					enabledAnalyzers: true,
					enabledExcel: false,
					realTimeSearchID: idSearch.value,
					directSite: tableDataAccessDirectSite,
					brokers: tableDataAccessBrokers,
					disable: isSearching.value,
				}}
				columns={[
					websiteColumn(),
					dorColumn(),
					...COLUMN_PARAMS_LIST.map(({ key, label, displayFilters = true, filterType = 'dropdown' , display = true, providerLogo = false }) => {
						return staticColumn(key, label, filterType, displayFilters, display, providerLogo)
					}),
					priceColumn(firstThirdIndex, secondThirdIndex),
				]}
				options={{
					viewColumns: true,
					search: true,
					enhancedSetRowProps: (rowData, dataIndex, idx) => ({
						sx: {
							backgroundColor: idx % 2 === 0 ? dsColorNew.white : dsColorNew.tableRowAlt,
							borderColor: dsColorNew.grayBorder,
							'& td': {
								padding: 0,
							},
						},
					}),
				}}
			/>
		</Grid>}
	</Grid>
}